import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import './About.css';

const About = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: 'Our Mission',
      body: 'OMNI helps professionals connect, share, and manage their digital identities seamlessly. We build tools that make networking meaningful and effortless.',
    },
    {
      title: 'What You Can Do',
      body: 'Create and share interactive business cards, extract contacts from physical cards, organize your connections, and tap to share with NFC-enabled devices.',
    },
    {
      title: 'Version',
      body: 'OMNI Web v1.3.8',
    },
    {
      title: 'Get in Touch',
      body: 'Questions or feedback? Reach us at support@my-omni.link. We would love to hear from you.',
    },
  ];

  return (
    <div className="about-container">
      <div className="about-content">

        {/* Back button */}
        <button className="about-back-btn" onClick={() => navigate('/settings')}>
          <FiArrowLeft size={20} />
          <span>Back</span>
        </button>

        {/* Header */}
        <div className="about-header">
          <h1 className="about-title">About OMNI</h1>
          <p className="about-subtitle">Learn more about the platform powering your connections</p>
        </div>

        {/* Hero Card */}
        <div className="about-hero-card">
          <p className="about-hero-lead">Built for modern networking.</p>
          <p className="about-hero-body">
            OMNI centralizes your professional presence so you can focus on creating genuine relationships.
          </p>
        </div>

        {/* Sections */}
        <div className="about-sections">
          {sections.map((section) => (
            <div key={section.title} className="about-section">
              <h3 className="about-section-title">{section.title}</h3>
              <p className="about-section-body">{section.body}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default About;
